<template>
  <div class="nav-header color-lighter">
    <div class="row gap-2">
      <AppIcon
        name="home"
        size="body-xl"
        :onClick="navigateToHome"
        :clickable="true"
      />
      <BreadCrumbs v-if="showBreadcrumb" />
    </div>
    <!-- Slot for custom content -->
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import RouteNames from '@/configuration/router/names.routes';
import navigationService from '@/services/NavigationService';
import { onMounted, ref } from 'vue';
import BreadCrumbs from './breadcrumbs/BreadCrumbs.vue';

const showBreadcrumb = ref(false);

onMounted(() => {
  showBreadcrumb.value =
    navigationService.getCurrentRoute().name !== RouteNames.Home;
});

function navigateToHome() {
  navigationService.navigateTo({ name: RouteNames.Home });
}
</script>

<style scoped lang="scss">
.nav-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: $space-4;

  @media (max-height: $small-screen-height) {
    margin-bottom: $space-2;
  }
}
</style>
